"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpeedtestApiImpl = void 0;
const ApiImplBase_1 = require("./ApiImplBase");
class SpeedtestApiImpl extends ApiImplBase_1.ApiImplBase {
    constructor(baseUrl, apiKey, logger, defaultTimeout) {
        super(baseUrl, apiKey, logger, defaultTimeout);
    }
    //TODO: Change http method to PUT (after new version of backend is deployed)
    abort(speedtestId) {
        return this.requestRx(`/abort/${encodeURIComponent(speedtestId)}`, "GET", undefined, 2000);
    }
    calcBenchmark(calcBenchmarkRequestModel) {
        return this.requestRx(`/calc/benchmark/`, "PUT", calcBenchmarkRequestModel);
    }
    calcDownload(calcDownloadRequestModel) {
        return this.requestRx(`/calc/download/`, "PUT", calcDownloadRequestModel);
    }
    calcPing(calcPingRequestModel) {
        return this.requestRx(`/calc/ping/`, "PUT", calcPingRequestModel);
    }
    calcUpload(calcUploadRequestModel) {
        return this.requestRx(`/calc/upload/`, "PUT", calcUploadRequestModel);
    }
    complete(completeRequestModel) {
        return this.requestRx(`/complete/`, "PUT", completeRequestModel);
    }
    configGet() {
        return this.requestRx(`/config/`, "GET");
    }
    initialize(initRequestModel) {
        return this.requestRx(`/init/`, "POST", initRequestModel);
    }
    modem(speedtestId) {
        return this.requestRx(`/modem/${encodeURIComponent(speedtestId)}`, "GET");
    }
    tipsKeys(speedtestId) {
        return this.requestRx(`/tipsKeys/${encodeURIComponent(speedtestId)}`, "GET");
    }
    print(printRequestModel) {
        return this.requestBlobRx("/print/", "POST", printRequestModel);
    }
    updateValue(valueRequestModel) {
        return this.requestRx(`/values/`, "POST", valueRequestModel);
    }
}
exports.SpeedtestApiImpl = SpeedtestApiImpl;
//# sourceMappingURL=SpeedtestApiImpl.js.map